import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseMetric } from './base-metric';
export var UntilExperience = /*#__PURE__*/function () {
  function UntilExperience(config) {
    _classCallCheck(this, UntilExperience);
    if (config instanceof BaseMetric) {
      this.experience = config;
    } else {
      this.experience = config.experience;
      this.useFmpAsUntilStopTime = config.useFmpAsUntilStopTime;
    }
  }

  /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */
  _createClass(UntilExperience, [{
    key: "getFmp",
    value: function getFmp() {
      var _marks$UntilExperienc;
      var _this$experience$getD = this.experience.getData(),
        marks = _this$experience$getD.marks,
        stop = _this$experience$getD.stop;
      return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
    }
  }, {
    key: "getDependencyStopTime",
    value: function getDependencyStopTime() {
      if (this.useFmpAsUntilStopTime) {
        return this.getFmp();
      }
      return this.experience.getData().stop;
    }

    /**
     * Get the time it takes for a segment to become fully interactable,
     * regardless of whether it uses the FMP as the stop time. (Eventual load)
     */
  }, {
    key: "getFullyInteractiveStopTime",
    value: function getFullyInteractiveStopTime() {
      return this.experience.getData().stop;
    }
  }, {
    key: "getIsSegmentLoadOverrided",
    value: function getIsSegmentLoadOverrided() {
      if (this.useFmpAsUntilStopTime) {
        var _this$experience$getD2 = this.experience.getData(),
          marks = _this$experience$getD2.marks;
        return marks[UntilExperience.FMP] ? true : false;
      }
      return false;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return this.experience.getData().key;
    }
  }]);
  return UntilExperience;
}();
_defineProperty(UntilExperience, "FMP", 'fmp');